import { createAction } from '@reduxjs/toolkit';
//import { ErrorObject } from '../StoreConstants';
import { AuthenticationModalInitialState } from './InitialState';

const Types = {
  SHOW_AUTHENTICATION: 'SHOW_AUTHENTICATION',
  HIDE_AUTHENTICATION: 'HIDE_AUTHENTICATION',
}

const Creators = {
  showAuthenthication: createAction<AuthenticationModalInitialState>(Types.SHOW_AUTHENTICATION),
  hideAuthentication: createAction(Types.HIDE_AUTHENTICATION),
}

export { Types };
export default Creators;